
define('mono', ['jquery', 'marionette']);
